<ifc-offer-disclosures [disclosures]="disclosures"></ifc-offer-disclosures>
